// to store and manage your global history instance anywhere in project which don't have access of history
import {createBrowserHistory} from 'history';

const history = createBrowserHistory();

export default history;
